import { ButtonsPanel } from './ButtonPanel';
import { connectButtonPanel } from './ButtonPanel.connect';

export { OpenInLifecycleButton } from './OpenInLifecycleButton';

export const ConnectedButtonsPanel = connectButtonPanel(ButtonsPanel);
ConnectedButtonsPanel.displayName = 'ConnectedButtonsPanel';
